import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { workflowSchemeConfigEntrypoint } from '@jira/spa-apps__project-settings-workflow-scheme-config/src/workflowSchemeConfigEntrypoint.entrypoint.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskWorkflowConfigRoute } from '@jira/router-routes__project-settings-workflow-scheme-config-routes/src/servicedeskWorkflowConfigRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const workflowSchemeConfigPageEntrypoint = createPageEntryPoint({
	main: workflowSchemeConfigEntrypoint,
});

export const servicedeskWorkflowConfigRouteEntry: Route = createEntry(
	servicedeskWorkflowConfigRoute,
	() => ({
		group: 'project-settings-servicedesk',

		entryPoint() {
			return workflowSchemeConfigPageEntrypoint;
		},

		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources(), projectContextResource],

		meta: {
			reporting: {
				id: 'project-settings.workflow-scheme-config',
				packageName: 'projectSettingsWorkflowSchemeConfig',
				teamName: 'jsd-shield',
			},
		},

		ufoName: 'project-settings-workflow-scheme-config',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
